import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Setup1 from '../views/Setup1.vue'
import ListView from '../views/ListView.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'setup',
    component: Setup1
  },
  {
    path: '/list',
    name: 'list',
    component: ListView
  },
  {
    path: '/tour',
    name: 'tour',
    component: HomeView
  },
  
  { path: "/tour", redirect: "/" }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
